/* should we combine type of HVE with the status of data entries?
my preference is to keep it simple and have a state that's unique
to each combination of type and data
*/

/**
 * Dev Note: This is the first time using enum from typescript.
 *
 * For more reading or alternative if bugs infest, check out https://www.typescriptlang.org/docs/handbook/enums.html#enums-at-compile-time
 */

export enum hveStates {
  coreLogic = 'core_logic',
  hpi = 'hpi',
  widget = 'widget',
  unsupported = 'unsupported'
}

export enum valueOrigins {
  CoreLogic = 'core_logic',
  HomePriceIndex = 'home_price_index',
  Unsupported = 'unsupported'
}
